module.exports = __webpack_public_path__ + "img/2.645f4eaf.png";